import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Theme,
} from "@mui/material";
import AppTableHeaderCell from "../../common/pages/AppTableHeaderCell";
import { StyledTableRow } from "../../../../styles/Shipmentstyles";
import AppTableRowCell from "../../common/pages/AppTableRowCell";
import "dayjs/locale/en-gb";
import AppTablePagenation from "../../common/pages/AppTablePagenation";
import { SortType } from "../../../../models/SortType";
import { formatDate } from "../../common/functions/formatDate";
import CustomTypography from "../../common/form/CustomTypography";
import { Shipments } from "../../../../models/Shipments";

interface DispatchOpsTableProps {
  data: Shipments[];
  maxHeight: number;
  page_no: number;
  limit: number;
  total_count: number;
  sortBy: string;
  sortType: SortType;
  minHeight: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange: (limit: number) => void;
  onSortChange: (column: string, sortType: SortType) => void;
}

const DispatchOpsTable: React.FC<DispatchOpsTableProps> = ({
  data,
  maxHeight,
  page_no,
  limit,
  total_count,
  sortBy = "created_date",
  sortType = SortType.DESC,
  minHeight = window.innerHeight - 350,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
}) => {
  const theme = useTheme<Theme>();

  const handleRowsChange = (value: number) => {
    onPageChange(null, 1);
    onRowsPerPageChange(value);
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: maxHeight, minHeight: minHeight }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AppTableHeaderCell
                minWidth="70px"
                sortColumn={"id"}
                title="ID/ Name"
                sx={{
                  textAlign: "left",
                }}
              />
              <AppTableHeaderCell title="Email 1/ Email 2" />
              <AppTableHeaderCell title="Status" />
              <AppTableHeaderCell title="Dimensions" />
              <AppTableHeaderCell title="Weight" />
              <AppTableHeaderCell title="Source/ Type" />
              <AppTableHeaderCell title="Country/ State" />
              <AppTableHeaderCell title="City/ Pin Code" />
              <AppTableHeaderCell title="Phone 1/ Phone 2" />
              <AppTableHeaderCell title="Address 1/ Address 2" />
              <AppTableHeaderCell title="Dispatch Date" />
              <AppTableHeaderCell title="Expected Delivery" />
              <AppTableHeaderCell title="Packs" />
              <AppTableHeaderCell title="AWB Number" />
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              data.map((item: any) => (
                <StyledTableRow key={item.id}>
                  <AppTableRowCell
                    minWidth="70px"
                    textAlign="left"
                    sx={{
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    {"#" + item.id} <br />
                    {`${item.first_name} ${
                      item.last_name ? ` ${item.last_name}` : ""
                    } ` || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {`${item.email} ${
                      item.alternate_email_id
                        ? `, ${item.alternate_email_id}`
                        : ""
                    } ` || "-"}
                  </AppTableRowCell>
                  <AppTableRowCell>{item.status_label || "-"}</AppTableRowCell>

                  <AppTableRowCell>
                    {item.length && `${item.length}`}
                    {item.length && item.breadth && ` * `}
                    {item.breadth && `${item.breadth}`}
                    {item.breadth && item.height && ` * `}
                    {(item.height && `${item.height}`) || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {(item.weight && `${item.weight}`) || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {item.shipment_type_label || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {`${item.country} ${
                      item.state ? `, ${item.state}` : ""
                    } ` || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {`${item.city} ${
                      item.pincode ? `, ${item.pincode}` : ""
                    } ` || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {`${item.phone} ${
                      item.alternate_phone ? `, ${item.alternate_phone}` : ""
                    } ` || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell minWidth="320px">
                    {`${item.address1}${
                      item.address2 ? `, ${item.address2}` : ""
                    }${item.address3 ? `, ${item.address3}` : ""}` || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {formatDate(item.dispatch_date) || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>
                    {formatDate(item.expected_delivery_date) || "-"}
                  </AppTableRowCell>

                  <AppTableRowCell>{item.packs_label || "-"}</AppTableRowCell>

                  <AppTableRowCell>
                    {item.awb_track_url ? (
                      <a
                        href={item.awb_track_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.awb || "-"}
                      </a>
                    ) : (
                      item.awb || "-"
                    )}
                  </AppTableRowCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <TableCell
                  colSpan={14}
                  sx={{
                    borderBottom: "none !important",
                    textAlign: "center",
                    paddingTop: 15,
                    paddingBottom: 15,
                  }}
                >
                  <CustomTypography
                    color={theme.palette.customColors.greyTextColor}
                    variant="body2"
                  >
                    NO Shipments FOUND!
                  </CustomTypography>
                </TableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <AppTablePagenation
        fontSize="0.8rem"
        pageNo={page_no}
        limit={limit}
        totalCount={total_count}
        onPageChange={onPageChange}
        handleRowsChange={handleRowsChange}
      />
    </>
  );
};

export default DispatchOpsTable;
